import { render, staticRenderFns } from "./ResidentList.vue?vue&type=template&id=8f01a41a&"
import script from "./ResidentList.vue?vue&type=script&lang=js&"
export * from "./ResidentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f01a41a')) {
      api.createRecord('8f01a41a', component.options)
    } else {
      api.reload('8f01a41a', component.options)
    }
    module.hot.accept("./ResidentList.vue?vue&type=template&id=8f01a41a&", function () {
      api.rerender('8f01a41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/ResidentList.vue"
export default component.exports